import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCE9P0hHJJ/1KbVekXRBWGO95bnwAgKOHMt/C0fJB3iDaGw+yxmuaHTdDMlBTxi0TDF8tv9ENzHtg15Bq68ZtY+Fe4PEkfwLKbRDZF8YmowcYhaBHevZ47DQgX0v9IitOoT3Sdj6YtVKoQiAK6USwHSt94HeejhoceJLFyGBRDd6wIDAQAB'
const pwdPublicKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoxtiI0KRBWeGvz2/x/G7MvKU4GwkqGNc2FHTrhYZ/Cvp/Inl4NyVljC37t1ecY8mibGIwl8YSsiRp+Qdfsul7Wmwy8tPeMrw8WOQ/mHBnhjPP3ozah/RGqnoRyeI7tnwtrWKAcjClW+KDWjrUvNKmr3eYQ/Zmio99l67XYYyTDRsVHlUpuwVxO+FtOcFCL6Rb3WHxKTMtNlgNd0z3kor7MY2t/oJurG9uCF2uOTL5KRS4w/vnd3d0LH9Y+tzc8wQuaiQcCqoAEj3cGO9X9VvRfuC28zWdznliedQwjrIMNlK3sWNW9wKv/jEsdrcO4OSUlci0/2LFLYnL+70uDcD9wIDAQAB";

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

export function encryptPwd(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pwdPublicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}


